import React, { useState, useEffect } from "react";
import Button from "./Button";
import { useStateContext } from "../contexts/ContextProvider";
import { useNavigate } from "react-router-dom";
import {
  apiChangeEmail,
  apiConfirmEmail,
  apiVerifyCurrentEmail,
  loginUser,
  verifyUser,
} from "../services/apiService";

const initialErrorState = {
  login: "",
  requestError: "",
};

const VerificationCode = (props) => {
  const { email, newEmail, roomId, inviteId, type, customFunc } = props;
  const { checkAuth, setNavigateToDashboard } = useStateContext();
  const [countDown, setCountDown] = useState(60);
  const [error, setError] = useState(initialErrorState);
  const [apiError, setApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [key, setKey] = useState("");
  const [code, setCode] = useState({
    code1: "",
    code2: "",
    code3: "",
    code4: "",
    code5: "",
    code6: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (countDown <= 0) {
      return;
    }
    const timer = setInterval(() => {
      setCountDown((prevState) => prevState - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [countDown]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    const reg = new RegExp("^[0-9]+$"); // integers or empty?
    let safeValue;

    if (reg.test(Number(value))) {
      if (value.length >> 1) {
        safeValue = key;
      } else {
        safeValue = value;
      }
    } else {
      return;
    }

    setCode((prevState) => ({ ...prevState, [name]: safeValue }));
    let n = Number(name.slice(name.length - 1, name.length));
    if (n <= 5 && key !== "Backspace") {
      document.getElementById(`code${n + 1}`).focus();
    }
  };

  const handleKeyDown = (event) => {
    const { name } = event.target;
    setKey(event.key);

    if (name === "code6" && event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (type === "signup") customFunc(code);
    else if (type === "confirm-email") confirmEmail();
    else if (type === "change-email") changeEmail();
    else attemptLogin();
  };

  const attemptLogin = async () => {
    const payload = {
      email,
      password:
        code.code1 +
        code.code2 +
        code.code3 +
        code.code4 +
        code.code5 +
        code.code6,
    };
    const response = await loginUser(payload);
    // console.log(response);
    if (response.hasError) {
      setApiError(true);
      response.error.status === 400
        ? setErrorMessage("Invalid code, please try again.")
        : setErrorMessage(response.error.message);
      activateError("login");
      resetCode();
      return;
    } else {
      await checkAuth();
      if (roomId) {
        setNavigateToDashboard(false);
        navigate(`/rooms/${roomId}?position=message`);
      } else if (inviteId) {
        localStorage.setItem("inviteId", inviteId);
      }
      navigate("/dashboard");
    }
  };

  const confirmEmail = async () => {
    const payload = {
      email,
      password:
        code.code1 +
        code.code2 +
        code.code3 +
        code.code4 +
        code.code5 +
        code.code6,
    };
    const response = await apiConfirmEmail(payload);
    if (response.hasError) {
      console.log(response.error.message);
      resetCode();
      activateError("login");
    } else {
      console.log(response.data.message);
      customFunc();
    }
  };

  const changeEmail = async () => {
    const payload = {
      email: newEmail,
      password:
        code.code1 +
        code.code2 +
        code.code3 +
        code.code4 +
        code.code5 +
        code.code6,
    };
    const response = await apiChangeEmail(payload);
    if (response.hasError) {
      console.log(response.error.message);
      resetCode();
      activateError("login");
    } else {
      console.log(response.data.message);
      customFunc();
    }
  };

  const handleResend = async () => {
    if (countDown > 0) {
      return;
    } else {
      resetCode();
      setCountDown(300);
      // const response =
      type === "confirm-email" || type === "change-email"
        ? await apiVerifyCurrentEmail({ email, newEmail })
        : await verifyUser({ email });
      // console.log(response);
      // if (response.hasError) {
      //   setApiError(true);
      //   response.error.status === 404
      //     ? setErrorMessage("Error - Account does not exist.")
      //     : setErrorMessage(response.error.message);
      //   activateError("requestError");
      //   return;
      // } else {
      console.log("Code sent");
    }
  };

  const resetError = () => {
    setApiError(false);
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  const resetCode = () => {
    setCode({
      code1: "",
      code2: "",
      code3: "",
      code4: "",
      code5: "",
      code6: "",
    });
  };

  return (
    <div className="pt-10">
      <div className="flex justify-center text-xl">Enter code sent to:</div>
      <div className="flex justify-center text-blue-500 text-lg text-center px-10 mt-2">
        {email.toLowerCase()}
      </div>
      <div className="flex justify-center items-center text-3xl pt-5 pb-5 mt-5">
        <input
          id="code1"
          name="code1"
          type="tel"
          autoFocus={true}
          value={code.code1}
          className={`h-20 w-10 border-gray-300 border-2 m-0.5 p-2 rounded-lg 
            focus:outline-snappily-orange focus:border-snappily-orange ${error.login}`}
          onClick={apiError ? resetError : () => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <input
          id="code2"
          name="code2"
          type="tel"
          value={code.code2}
          className={`h-20 w-10 border-gray-300  border-2 m-0.5 p-2 rounded-lg 
            focus:outline-snappily-orange focus:border-snappily-orange ${error.login}`}
          onClick={apiError ? resetError : () => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <input
          id="code3"
          name="code3"
          type="tel"
          value={code.code3}
          className={`h-20 w-10 border-gray-300  border-2 m-0.5 p-2 rounded-lg 
            focus:outline-snappily-orange focus:border-snappily-orange ${error.login}`}
          onClick={apiError ? resetError : () => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <div>-</div>
        <input
          id="code4"
          name="code4"
          type="tel"
          value={code.code4}
          className={`h-20 w-10 border-gray-300  border-2 m-0.5 p-2 rounded-lg 
            focus:outline-snappily-orange focus:border-snappily-orange ${error.login}`}
          onClick={apiError ? resetError : () => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <input
          id="code5"
          name="code5"
          type="tel"
          value={code.code5}
          className={`h-20 w-10 border-gray-300  border-2 m-0.5 p-2 rounded-lg 
            focus:outline-snappily-orange focus:border-snappily-orange ${error.login}`}
          onClick={apiError ? resetError : () => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <input
          id="code6"
          name="code6"
          type="tel"
          value={code.code6}
          className={`h-20 w-10 border-gray-300  border-2 m-0.5 p-2 rounded-lg 
            focus:outline-snappily-orange focus:border-snappily-orange ${error.login}`}
          onClick={apiError ? resetError : () => {}}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div>
        <div className="flex justify-center text-sm">
          Didn't receive code?
          <span
            className={`${
              countDown === 0
                ? "text-blue-500 hover:text-blue-700 cursor-pointer"
                : "text-slate-400"
            }`}
            onClick={handleResend}
          >
            &nbsp; Send Again {countDown === 0 ? "" : `in (${countDown})`}
          </span>
        </div>

        <div className="flex justify-center text-sm text-red-500 mt-3">
          (Code expires after 10 minutes)
        </div>
      </div>
      {code.code1 &&
        code.code2 &&
        code.code3 &&
        code.code4 &&
        code.code5 &&
        code.code6 && (
          <div className="flex justify-center py-10">
            <Button
              id="submit-button"
              background="bg-snappily-orange"
              text="text-white hover:text-black"
              opacity="bg-opacity-100"
              title={
                type === "confirm-email"
                  ? "Verify"
                  : type === "change-email"
                  ? "Confirm Change"
                  : type === "signup"
                  ? "Create Account"
                  : "Login"
              }
              height="h-10"
              width="w-72"
              tabIndex="6"
              borderHover="hover:bg-white"
              customFunc={handleSubmit}
            />
          </div>
        )}
      {apiError && (
        <div className="flex justify-center h-10 mt-2 text-red-600">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default VerificationCode;
